import { apiSlice } from "../apiSlice";

export const termsAndConditionsMenuApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getTermsAndConditionsMenu: builder.query({
      query: () => "terms_and_conditions/menu",
      transformResponse: (responseData) => responseData?.data ?? [],
    }),
  }),
});

export const { useGetTermsAndConditionsMenuQuery } =
  termsAndConditionsMenuApiSlice;